module.exports = ".example-form {\r\n    \r\n    display: -webkit-box;\r\n    \r\n    display: -ms-flexbox;\r\n    \r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n  }\r\n  \r\n  .example-full-width {\r\n    width: 100%;\r\n  }\r\n  \r\n  .example-half-width {\r\n    width: 50%;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/public/contacts/addContactDialog.component.css
// module id = ./src/app/public/contacts/addContactDialog.component.css
// module chunks = main